import FinanceSettlementRequest from '@/models/finance/FinanceSettlementRequest';
import FinanceSettlementResult from '@/models/finance/FinanceSettlementResult';
import IFinanceSettlementState from './interfaces/finance-settlement-state.d';

export default class FinanceSettlementState implements IFinanceSettlementState {
  public contractStartDateString: string = '';

  public formattedContractStartDate: Date = new Date();

  public financeSettlementRequest: FinanceSettlementRequest = new FinanceSettlementRequest();

  public financeSettlementResult: FinanceSettlementResult = new FinanceSettlementResult();
}
